<template>
    <div class="investigate-form">
      <van-form>
        <van-field
        placeholder="账号"
         style="font-size: 22px;margin: 30px 0" v-model.trim="submitValue.UserAccount" label="账号:"></van-field>
        <van-field
        placeholder="账号昵称"
        style="font-size: 22px;margin: 30px 0" v-model.trim="submitValue.NickName" label="账号昵称:"></van-field>
        <van-field
        placeholder="手机号"
          type="number"
          v-model.trim="submitValue.Mobile"
          label="手机号:"
          style="font-size: 22px;margin: 30px 0"
        ></van-field>
        <van-field
        placeholder="密码"
        style="font-size: 22px;margin: 30px 0"
          :type="showPassword1 ? 'text' : 'password'"
          v-model.trim="submitValue.Password"
          label="密码:"
        >
          <template #right-icon>
            <van-icon
              :name="showPassword1 ? 'eye-o' : 'closed-eye'"
              @click="togglePasswordVisibility1"
            />
          </template>
        </van-field>
        <van-field
        placeholder="确认密码"
        style="font-size: 22px;margin: 30px 0"
          :type="showPassword ? 'text' : 'password'"
          v-model.trim="submitValue.ConfirmPassword"
          label="确认密码:"
        >
          <template #right-icon>
            <van-icon
              :name="showPassword ? 'eye-o' : 'closed-eye'"
              @click="togglePasswordVisibility"
            />
          </template>
        </van-field>
      </van-form>
      <div class="sub">
        <van-button
         style="font-size: 22px"
        size="small" type="primary" @click="Submit"
          >提交</van-button
        >
      </div>
    </div>
</template>
<script>
import { CreateHealthcarePractitioner } from '@/api/index'
export default {
  data () {
    return {
      showPassword: false,
      showPassword1: false,
      submitValue: {
        UserAccount: '',
        NickName: '',
        Password: '',
        Mobile: '',
        ConfirmPassword: '',
        Id: this.$query('id')
      }
    }
  },
  created () {},
  methods: {
    togglePasswordVisibility () {
      this.showPassword = !this.showPassword
    },
    togglePasswordVisibility1 () {
      this.showPassword1 = !this.showPassword1
    },
    Submit () {
      const phoneRegex = /^1[345789]\d{9}$/
      if (!phoneRegex.test(this.submitValue.Mobile)) {
        this.$toast.fail({
          message: '请输入正确手机号！'
        })
        return
      }
      if (this.submitValue.Password !== this.submitValue.ConfirmPassword) {
        this.$toast.fail({
          message: '两次密码不一致！'
        })
        return
      }
      if (this.submitValue.Password === '') {
        this.$toast.fail({
          message: '密码不能为空！'
        })
        return
      }
      if (this.submitValue.ConfirmPassword === '') {
        this.$toast.fail({
          message: '确认密码不能为空！'
        })
        return
      }
      if (this.submitValue.UserAccount === '') {
        this.$toast.fail({
          message: '账号不能为空！'
        })
        return
      }
      if (this.submitValue.NickName === '') {
        this.$toast.fail({
          message: '账号昵称不能为空！'
        })
        return
      }
      CreateHealthcarePractitioner(this.submitValue).then((res) => {
        if (!res.code) {
          this.$toast.success({
            message: '提交成功！'
          })
        } else {
          this.$toast.fail({
            message: res.msg
          })
        }
        // this.submitValue.UserAccount = ''
        // this.submitValue.NickName = ''
        // this.submitValue.Password = ''
        // this.submitValue.Mobile = ''
        // this.submitValue.ConfirmPassword = ''
        this.showPassword = false
        this.showPassword1 = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.sub {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
  }
.investigate-form {
  display: flex;
  flex-direction: column;
  justify-content: center; /* 垂直居中 */
  height: 100vh; /* 视窗高度 */
  width: 100%; /* 视窗宽度 */
  padding: 20px; /* 添加一些内边距 */
}

</style>
